<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
  import { loginOut } from '@/api/apis'
export default {
  components: {
  },

  data() {
    return {

    };
  },
created(){

},
 mounted() {
    let beginTime = 0; //开始时间
    let differTime = 0; //时间差
   window.onload = function () {
     if (!window.sessionStorage['ISLogin']) {
       localStorage.clear();
       this.$router.push({ name: "login2" });
       // loginOut().then(res=>{
       //
       // })
     }
   }
    window.onunload = function () {
      differTime = new Date().getTime() - beginTime;
      if (differTime <2) {
        console.log("这是关闭");
        localStorage.setItem("token", "");
      } else {
        console.log("这是刷新");
      }
      window.sessionStorage['ISLogin'] = true
    };

    window.onbeforeunload = function () {
      beginTime = new Date().getTime();
      window.sessionStorage['ISLogin'] = true
    };
  },

  methods: {

  },
};
</script>

<style lang="scss">
@import "@/assets/style/_varable.scss";
// @import "@/assets/style/qx.main.scss";
html,body{
  background-color: $bg-light;
}
#app {
  width: 100%;
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: $bg-light;
}
// .header {
//   .header-top {
//     margin-bottom: 16px;
//     padding: 16px 0;
//   }
// }
/*简单的样式库*/

/* 阴影 */
.shadow-sm {
  box-shadow: 0 2px 4px rgba(114, 130, 138, 0.2) !important;
}
.shadow {
  box-shadow: 0 8px 16px rgba(114, 130, 138, 0.2) !important;
}
.shadow-lg {
  box-shadow: 0 16px 48px rgba(114, 130, 138, 0.2) !important;
}

/* 定位 */
.position-absolute {
  position: absolute;
}
.position-fixed {
  position: fixed;
}
.position-relative {
  position: relative;
}
.left-0 {
  left: 0;
}
.top-0 {
  top: 0;
}
.bottom-0 {
  bottom: 0;
}
.right-0 {
  right: 0;
}

/* 宽高 */
.w {
  width: 1920px;
}
.w-100 {
  width: 100%;
}
.w-50 {
  width: 1200px;
}
.h-100 {
  height: 100%;
}

/* 字体大小 */
.font-sm {
  font-size: 14px;
}
.font {
  font-size: 16px;
}
.font1 {
  font-size: 18px;
}
.font-md1 {
  font-size: 20px;
}
.font-md2 {
  font-size: 22px;
}
.font-md3 {
  font-size: 24px;
}
.font-lg {
  font-size: 30px;
}
.font-lg1 {
  font-size: 38px;
}
.font-big {
  font-size: 56px;
}
.font-weight {
  font-weight: bold !important;
}
.font-weight-100 {
  font-weight: 100 !important;
}
.font-weight1 {
  font-weight: normal;
}

/* 字体颜色 */
.font-color {
  color: $bg-white;
}
.font-color1 {
  color: $bg-primary-d2;
}
.font-color2 {
  color: $text-secondary;
}
.font-color3 {
  color: $text-secondary1;
}
.font-color4 {
  color: $text-dark;
}
.font-color5 {
  color: $bg-primary;
}
/* 字体对齐 */
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}

/* 行高 */
.line-h0 {
  line-height: 0 !important;
}
.line-h {
  line-height: 1 !important;
}
.line-h-sm {
  line-height: 1.2 !important;
}
.line-h-md {
  line-height: 1.5 !important;
}
.line-h-lg {
  line-height: 2 !important;
}
.line-h-big {
  line-height: 3 !important;
}

/* 删除线*/
.line-through {
  text-decoration: line-through;
}

/* 间距 */
.letter-sp {
  letter-spacing: 3px;
}
.letter-sp0 {
  letter-spacing: 4px;
}
.letter-sp1 {
  letter-spacing: 8px;
}

/* 布局 */
row {
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: wrap;
}
[class*="col-"],
[class*="span-"],
[class*="span24-"] {
  min-height: 1px;
  box-sizing: border-box !important;
}
/* 栅栏一 */
.col-1 {
  width: 62.5px;
}
.col-2 {
  width: 125px;
}
.col-3 {
  width: 187.5px;
}
.col-4 {
  width: 250px;
}
.col-5 {
  width: 312.5px;
}
.col-6 {
  width: 375px;
}
.col-7 {
  width: 437.5px;
}
.col-8 {
  width: 500px;
}
.col-9 {
  width: 562.5px;
}
.col-10 {
  width: 625px;
}
.col-11 {
  width: 687.5px;
}
.col-12 {
  width: 750px;
}
/* 栅栏二 */
.span-1 {
  width: 5%;
}
.span-2 {
  width: 10%;
}
.span-3 {
  width: 15%;
}
.span-4 {
  width: 20%;
}
.span-5 {
  width: 25%;
}
.span-6 {
  width: 30%;
}
.span-7 {
  width: 35%;
}
.span-8 {
  width: 40%;
}
.span-9 {
  width: 45%;
}
.span-10 {
  width: 50%;
}
.span-11 {
  width: 55%;
}
.span-12 {
  width: 60%;
}
.span-13 {
  width: 65%;
}
.span-14 {
  width: 70%;
}
.span-15 {
  width: 75%;
}
.span-16 {
  width: 80%;
}
.span-17 {
  width: 85%;
}
.span-18 {
  width: 90%;
}
.span-19 {
  width: 95%;
}
.span-20 {
  width: 100%;
}
/* 栅栏三 */
.span24-1 {
  width: 4.17%;
}
.span24-2 {
  width: 8.33%;
}
.span24-3 {
  width: 12.5%;
}
.span24-4 {
  width: 16.67%;
}
.span24-5 {
  width: 20.83%;
}
.span24-6 {
  width: 25%;
}
.span24-7 {
  width: 29.17%;
}
.span24-8 {
  width: 33.33%;
}
.span24-9 {
  width: 37.5%;
}
.span24-10 {
  width: 41.67%;
}
.span24-11 {
  width: 45.83%;
}
.span24-12 {
  width: 50%;
}
.span24-13 {
  width: 54.17%;
}
.span24-14 {
  width: 58.33%;
}
.span24-15 {
  width: 62.5%;
}
.span24-16 {
  width: 66.67%;
}
.span24-17 {
  width: 70.83%;
}
.span24-18 {
  width: 75%;
}
.span24-19 {
  width: 79.17%;
}
.span24-20 {
  width: 83.33%;
}
.span24-21 {
  width: 87.5%;
}
.span24-22 {
  width: 91.67%;
}
.span24-23 {
  width: 95.83%;
}
.span24-24 {
  width: 100%;
}

/* flex 布局*/
.d-flex {
  display: flex;
  flex-direction: row !important;
}
.d-block {
  display: block;
}
.d-inline-block {
  display: inline-block;
}
.flex-1 {
  flex: 1;
}
.flex-column {
  flex-direction: column !important;
}
.flex-row {
  flex-direction: row;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.flex-shrink {
  flex-shrink: 0;
}
.j-start {
  justify-content: flex-start;
}
.j-center {
  justify-content: center !important;
}
.j-end {
  justify-content: flex-end;
}
.j-sb {
  justify-content: space-between;
}
.j-sa {
  justify-content: space-around;
}
.a-center {
  align-items: center !important;
}
.a-start {
  align-items: flex-start;
}
.a-end {
  align-items: flex-end;
}
.a-stretch {
  align-items: stretch;
}
.a-self-start {
  align-self: flex-start;
}
.a-self-auto {
  align-self: auto;
}
.a-self-end {
  align-self: flex-end;
}
.a-self-stretch {
  align-self: stretch;
}
.a-self-baseline {
  align-self: baseline;
}

/* border */
.border-none {
  border: 0 !important;
}
.border {
  border: 2px solid $text-dark;
}
.border1 {
  border: 1px solid $border-secondary;
}
.border2 {
  border: 1px solid $border-secondary1;
}
.border3 {
  border: 1px solid $border-secondary2;
}
.border4 {
  border: 1px solid $border-secondary3;
}

.border-tp {
  border: 1px solid $border-secondary1;
}
.border-tp1 {
  border: 1px dashed $text-secondary;
}

.border-bt {
  border: 1px dashed $text-secondary;
}

.rounded {
  border-radius: 4px;
}
.rounded-circle {
  border-radius: 100%;
}
.rounded-50 {
  border-radius: 50%;
}

.margin {
  margin: 0 auto;
}
.position-center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

/* 背景颜色*/
.bg-warning {
  background-color: $bg-warning !important;
}
.bg-parmary {
  background-color: $bg-primary-d !important;
}
.bg-parmary1 {
  background-color: $bg-primary-d2 !important;
}
.bg-white {
  background-color: $bg-white !important;
}
</style>
